import IconRover from '@apollo/icons/default/IconRover.svg';
import IconServices from '@apollo/icons/default/IconServices.svg';
import IconTooling from '@apollo/icons/default/IconTooling.svg';
import {
  Divider,
  Heading,
  Link,
  List,
  ListIcon,
  ListItem,
} from '@apollo/orbit';
import React, { useEffect, useRef } from 'react';

import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';
import { DocsRouter } from 'src/lib/routers';

export const NewToGraphOSStudioSection = ({
  userId,
}: {
  userId: string | undefined;
}) => {
  const videoWrapperRef = useRef<HTMLDivElement | null>(null);

  const trackCustomEvent = useTrackCustomEvent();
  useEffect(() => {
    if (videoWrapperRef.current) {
      const iframe = document.createElement('iframe');

      iframe.src = `https://fast.wistia.net/embed/iframe/2qlzojwo1n?seo=false&email=${userId}`;
      iframe.title = 'GraphOS README Video';
      iframe.allow = 'autoplay; fullscreen';
      iframe.frameBorder = '0';
      iframe.scrolling = 'no';
      iframe.name = 'wistia_embed';
      iframe.allowFullscreen = true;
      iframe.height = '200px';
      iframe.width = '100%';
      const script = document.createElement('script');
      script.src = 'https://fast.wistia.net/assets/external/E-v1.js';
      script.async = true;
      videoWrapperRef.current.appendChild(iframe);
      videoWrapperRef.current.appendChild(script);

      // when focus switches to the iframe, track a click.
      // caveat with this solution: if studio.apollographql.com is not
      // originally focused, we won't capture that user clicking into the iframe
      const blurFunc = () => {
        if (document.activeElement === iframe) {
          trackCustomEvent({
            action: 'click',
            category: 'Variant Home',
            label: 'Clicked Readme Wistia Video',
          });
        }
      };
      addEventListener('blur', blurFunc);
      return () => removeEventListener('blur', blurFunc);
    }
  }, [trackCustomEvent, userId]);

  return (
    <div>
      <Heading size="lg">New to GraphOS Studio?</Heading>
      <Divider className="mt-1" />
      <p className="mt-3">
        Check out a few quick tips and links from the Apollo team, designed to
        get you up and running.
      </p>
      <div ref={videoWrapperRef} className="my-4" />
      <List>
        <ListItem className="px-0">
          <ListIcon as={IconServices} />
          <Link
            isExternal
            data-analytics-category="Variant Home"
            data-analytics-label="Get to know your supergraph click"
            to={DocsRouter.path('GetToKnowYourSupergraph')}
          >
            Get to know your supergraph
          </Link>
        </ListItem>
        <ListItem className="px-0">
          <ListIcon as={IconRover} />
          <Link
            isExternal
            data-analytics-category="Variant Home"
            data-analytics-label="Automate tasks with the Rover CLI click"
            to={DocsRouter.path('Rover')}
          >
            Automate tasks with the Rover CLI
          </Link>
        </ListItem>
        <ListItem className="px-0">
          <ListIcon as={IconTooling} />
          <Link
            isExternal
            data-analytics-category="Variant Home"
            data-analytics-label="Build custom tools click"
            to={DocsRouter.path('PlatformAPI')}
          >
            Build custom tools with the GraphOS Platform API
          </Link>
        </ListItem>
      </List>
    </div>
  );
};
